import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import styles from "../../../styles/charts/chartStyle.module.css";
import { heatMapDataLabelStyler, titleStyler } from "../../../lib/util";

const HeatMap = (props: any) => {
  const { series, yLabel, xLabel, title } = props;

  let { axisTitleStyle } = titleStyler();
  let dataLabelStyle = heatMapDataLabelStyler();

  let options = {
    chart: {
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: true,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: false,
        },
        export: {
          csv: {
            filename: title,
            columnDelimiter: ",",
            headerCategory: xLabel,
            headerValue: yLabel,
            dateFormatter(timestamp: any) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: title,
          },
          png: {
            filename: title,
          },
        },
      },
    },
    plotOptions: {
      heatmap: {
        shadeIntensity: 0.5,
        radius: 0,
        useFillColorAsStroke: true,
        colorScale: {
          ranges: props.colorRange,
        },
      },
    },
    dataLabels: {
      enabled: true,
      style: dataLabelStyle,
      formatter: function (val: number) {
        return val.toFixed(2);
      },
      dropShadow: {
        enabled: true,
      },
    },
    stroke: {
      width: 1,
    },

    xaxis: {
      labels: {
        show: props.labels.x,
        trim: true,
        hideOverlappingLabels: false,
        rotate: -15,
      },
      title: {
        text: props.xLabel,
        offsetX: 0,
        offsetY: 70,
        style: axisTitleStyle,
      },
    },
    yaxis: {
      labels: {
        show: props.labels.y,
        trim: true,
        hideOverlappingLabels: false,
        rotate: 0,
      },
      title: {
        text: yLabel,
        offsetY: 0,
        offsetX: 5,
        style: axisTitleStyle,
      },
    },

    noData: {
      text: "Loading...",
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#000000",
        fontSize: "20px",
      },
    },
    legend: {
      show: false,
    },
  };

  return (
    <ReactApexChart
      series={series}
      type="heatmap"
      className={styles.the_chart}
      options={options as unknown as ApexOptions}
    />
  );
};

export default HeatMap;
